import { render, staticRenderFns } from "./edit-role-form.vue?vue&type=template&id=09e3789d&"
import script from "./edit-role-form.vue?vue&type=script&lang=js&"
export * from "./edit-role-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports